import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrideLength = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_99",
		"data-name": "Group 99",
		transform: "translate(0.5 0.5)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_98",
			"data-name": "Group 98",
			transform: "translate(9.007 1.467)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_233",
					"data-name": "Path 233",
					d: "M235.059,158.048a1.056,1.056,0,0,0,1.056-1.056v-3.167a1.056,1.056,0,0,0-2.111,0v3.167A1.056,1.056,0,0,0,235.059,158.048Z",
					transform: "translate(-234.001 -150.723)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_234",
					"data-name": "Path 234",
					d: "M235.059,171.283a1.056,1.056,0,0,0,1.056-1.056v-3.167a1.056,1.056,0,0,0-2.111,0v3.167A1.056,1.056,0,0,0,235.059,171.283Z",
					transform: "translate(-234.001 -156.972)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_235",
					"data-name": "Path 235",
					d: "M307.773,158.048a1.056,1.056,0,0,0,1.056-1.056v-3.167a1.056,1.056,0,1,0-2.111,0v3.167A1.056,1.056,0,0,0,307.773,158.048Z",
					transform: "translate(-268.334 -150.723)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_236",
					"data-name": "Path 236",
					d: "M307.773,171.283a1.056,1.056,0,0,0,1.056-1.056v-3.167a1.056,1.056,0,1,0-2.111,0v3.167A1.056,1.056,0,0,0,307.773,171.283Z",
					transform: "translate(-268.334 -156.972)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_237",
					"data-name": "Path 237",
					d: "M244.435,172.579a14.434,14.434,0,0,0-3.88.872c-.466.149-.907.29-1.166.348-.2.045-.451.087-.726.133-1.614.271-4.972.836-4.642,3.652a2.747,2.747,0,0,0,1.04,1.95c1.225.937,3.069.663,4.7.42a12.6,12.6,0,0,1,1.631-.179,4.728,4.728,0,0,1,1.355.272,8.518,8.518,0,0,0,2.6.445c2.264,0,4.64-1.151,4.8-3.352a3.619,3.619,0,0,0-.993-2.784A6.487,6.487,0,0,0,244.435,172.579Zm.909,5.8a6.46,6.46,0,0,1-2-.357,6.572,6.572,0,0,0-1.958-.361,13.813,13.813,0,0,0-1.942.2c-1.093.163-2.589.384-3.1-.008-.05-.039-.183-.14-.227-.519h0c-.08-.681,1.1-1.022,2.9-1.324.318-.053.6-.1.838-.155.352-.079.813-.226,1.348-.4a13.529,13.529,0,0,1,3.236-.772,4.509,4.509,0,0,1,3.17,1.105,1.513,1.513,0,0,1,.433,1.193C247.975,177.849,246.59,178.382,245.344,178.382Z",
					transform: "translate(-233.999 -160.076)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_238",
					"data-name": "Path 238",
					d: "M321.865,174.358a6.487,6.487,0,0,0-4.716-1.779,14.442,14.442,0,0,0-3.88.872c-.466.149-.906.29-1.166.348-.2.045-.45.087-.726.133-1.614.271-4.972.836-4.642,3.652a2.75,2.75,0,0,0,1.04,1.95c1.225.937,3.07.663,4.7.42a12.6,12.6,0,0,1,1.63-.179,4.731,4.731,0,0,1,1.355.272,8.518,8.518,0,0,0,2.6.445c2.264,0,4.64-1.151,4.8-3.352A3.617,3.617,0,0,0,321.865,174.358Zm-3.807,4.024a6.463,6.463,0,0,1-2-.357,6.573,6.573,0,0,0-1.958-.361,13.815,13.815,0,0,0-1.941.2c-1.093.163-2.589.384-3.1-.008-.05-.039-.183-.14-.227-.519h0c-.08-.681,1.1-1.022,2.9-1.324.318-.053.6-.1.837-.155.352-.079.813-.226,1.349-.4a13.528,13.528,0,0,1,3.236-.772,4.509,4.509,0,0,1,3.17,1.105,1.513,1.513,0,0,1,.433,1.193C320.689,177.849,319.3,178.382,318.058,178.382Z",
					transform: "translate(-268.332 -160.076)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_239",
					"data-name": "Path 239",
					d: "M281.444,192.376a8.531,8.531,0,0,0-2.6.445,4.732,4.732,0,0,1-1.355.272,12.515,12.515,0,0,1-1.631-.179c-1.627-.242-3.472-.517-4.7.421a2.749,2.749,0,0,0-1.04,1.95h0c-.33,2.816,3.028,3.381,4.642,3.652.276.046.524.088.726.133.26.058.7.2,1.167.348a14.427,14.427,0,0,0,3.88.873,6.486,6.486,0,0,0,4.715-1.779,3.614,3.614,0,0,0,.993-2.784C286.083,193.528,283.708,192.376,281.444,192.376Zm2.261,4.7a4.51,4.51,0,0,1-3.17,1.106,13.555,13.555,0,0,1-3.236-.772c-.535-.172-1-.319-1.349-.4-.233-.052-.519-.1-.838-.154-1.8-.3-2.974-.643-2.895-1.324h0c.044-.38.177-.481.227-.519a1.821,1.821,0,0,1,1.042-.22,15.094,15.094,0,0,1,2.06.212,13.821,13.821,0,0,0,1.942.2,6.557,6.557,0,0,0,1.958-.361,6.476,6.476,0,0,1,2-.357c1.247,0,2.631.533,2.693,1.394A1.513,1.513,0,0,1,283.7,197.074Z",
					transform: "translate(-251.044 -169.424)",
					fill: "#101820",
					opacity: .3
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_240",
					"data-name": "Path 240",
					d: "M274.178,153.16c.009-.021.013-.043.021-.065a1.078,1.078,0,0,0,.039-.132c.006-.032.006-.065.01-.1s.011-.07.011-.106-.007-.066-.01-.1a1.009,1.009,0,0,0-.011-.106,1.02,1.02,0,0,0-.037-.124c-.008-.024-.013-.049-.023-.073a1.006,1.006,0,0,0-.067-.126c-.011-.019-.018-.039-.031-.056a1.051,1.051,0,0,0-.134-.164l-2.809-2.81a1.055,1.055,0,0,0-1.493,1.493l1.009,1.01H242.2l1.01-1.01a1.056,1.056,0,1,0-1.493-1.493l-2.811,2.811a1.056,1.056,0,0,0,0,1.493h0l2.809,2.81a1.056,1.056,0,1,0,1.493-1.493l-1.009-1.009h28.45l-1.008,1.009a1.055,1.055,0,1,0,1.493,1.493l2.806-2.806a1.023,1.023,0,0,0,.138-.167c.01-.014.016-.03.025-.045A1.018,1.018,0,0,0,274.178,153.16Z",
					transform: "translate(-236.171 -148.891)",
					fill: "#101820"
				})
			]
		}), /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_28",
			"data-name": "Rectangle 28",
			width: 72.551,
			height: 33.802,
			transform: "translate(0 0)",
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		})]
	})]
});
const ForwardRef = forwardRef(SvgStrideLength);
export { ForwardRef as ReactComponent };
